import { render } from "./TaffyBtnGroups.vue?vue&type=template&id=0db04e9a&scoped=true"
import script from "./TaffyBtnGroups.vue?vue&type=script&lang=js"
export * from "./TaffyBtnGroups.vue?vue&type=script&lang=js"

import "./TaffyBtnGroups.vue?vue&type=style&index=0&id=0db04e9a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db04e9a"]])

export default __exports__